import React from 'react'
import { useSelector } from 'react-redux';
import './BillTypeTemplateSummaryThermal.css';
import { getFilteredCashCard, hasCashCardFilter, groupCashCardByType } from '../cashCardFilterUtils';

const BillTypeSummaryPrint = () => {
  const decimalPosition = localStorage.getItem("decimalPosition");
    
  const ShiftBillTypeSummary = useSelector((state) => state.posReportshiftSlice.billTypeSummary);
  const {showSubHeaders, paymentTypeSplit, cashCardSplit, cardNameFilter, bankJournalFilter} = useSelector((state) => state.posReportshiftSlice);

  const cashCardFilterActive = hasCashCardFilter(cardNameFilter, bankJournalFilter);
  const { rows: filteredCashCardRows, total: filteredCashCardTotal } = getFilteredCashCard(
    ShiftBillTypeSummary?.cashAndCard?.list,
    cardNameFilter,
    bankJournalFilter
  );
  const cashCardRowsToShow = cashCardFilterActive
    ? filteredCashCardRows
    : ShiftBillTypeSummary?.cashAndCard?.list || [];
  const cashCardGroups = groupCashCardByType(cashCardRowsToShow);
  // Use backend's delivery.total which correctly sums aggregator and selfDelivery counts
  const deliveryTotal = ShiftBillTypeSummary?.delivery?.total || 0

  const getPaymentTypeBreakdown = (list) => {
    if (!list || list.length === 0) return [];
    const map = {};
    list.forEach((item) => {
      const pt = item?.paymentType || "Unknown";
      map[pt] = (map[pt] || 0) + (item?.amount || 0);
    });
    return Object.entries(map).map(([type, amount]) => ({ type, amount }));
  };

  const staffExpBreakdown = paymentTypeSplit ? getPaymentTypeBreakdown(ShiftBillTypeSummary?.staffExpense?.list) : [];
  const outletExpBreakdown = paymentTypeSplit ? getPaymentTypeBreakdown(ShiftBillTypeSummary?.outletExpense?.list) : [];

  const getAllExpenseBreakdown = () => {
    const map = {};
    const allLists = [
      ...(ShiftBillTypeSummary?.staffExpense?.list || []),
      ...(ShiftBillTypeSummary?.outletExpense?.list || []),
    ];
    allLists.forEach((item) => {
      const pt = (item?.paymentType || "Unknown").toUpperCase();
      map[pt] = (map[pt] || 0) + (item?.amount || 0);
    });
    return map;
  };

  const getAfterExpensesRows = () => {
    if (!paymentTypeSplit) return [];
    const cashCardList = ShiftBillTypeSummary?.cashAndCard?.list || [];
    const expMap = getAllExpenseBreakdown();
    const rows = [];
    cashCardList.forEach((cc) => {
      const typeName = (cc?.type || "").toUpperCase();
      if (typeName === "CASH") return;
      const expAmount = expMap[typeName] || 0;
      if (expAmount > 0) {
        rows.push({
          type: `${cc?.type} After Expenses`,
          amount: (cc?.amount || 0) - expAmount,
        });
      }
    });
    return rows;
  };

  const afterExpensesRows = getAfterExpensesRows();
  return (
    <div
      className="thermal-receipt-container"
    >
      <div className="bill-main-head">
        <h5>Bill Type</h5>
        <h5>Amount</h5>
      </div>
      <div
        className="bill-sub-head"
      >
        <h5>Dine In</h5>
        <h5>
        {(ShiftBillTypeSummary?.dineIn?.total||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.dineIn?.list !== undefined ? (
              ShiftBillTypeSummary?.dineIn?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r?.billNo}
                  </td>
                  <td>
                    {r?.date}
                  </td>
                  <td>
                    {r?.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head"
      >
        <h5>Take Away</h5>
        <h5>
        {(ShiftBillTypeSummary?.takeAway?.total||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.takeAway?.list !== undefined ? (
              ShiftBillTypeSummary?.takeAway?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.billNo}
                  </td>
                  <td>
                    {r.date}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head"
      >
        <h5>Delivery</h5>
        <h5>
        {(deliveryTotal||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <div className="bill-sub2-head">
          <h5>{ShiftBillTypeSummary?.selfDelivery?.count?`(${ShiftBillTypeSummary?.selfDelivery?.count})`:""}</h5>
          <h5>
          {(ShiftBillTypeSummary?.selfDelivery?.total || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
      )}
      {showSubHeaders && (
        <table>
          <thead >
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.selfDelivery?.list !== undefined ? (
              ShiftBillTypeSummary?.selfDelivery?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.billNo}
                  </td>
                  <td>
                    {r.date}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {showSubHeaders && (
        <div className="bill-sub2-head">
          <h5>Aggregator{ShiftBillTypeSummary?.aggregator?.count?`(${ShiftBillTypeSummary?.aggregator?.count})`:""}</h5>
          <h5>
          {(ShiftBillTypeSummary?.aggregator?.total || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
      )}
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>O/ID</th>
              {/* <th>Date</th> */}
              <th>Disc</th>
              <th>Comm.</th>
              <th>Amt</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.aggregator?.list !== undefined ? (
              ShiftBillTypeSummary?.aggregator?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.aggregatorName}
                  </td>
                  <td>
                    {r.billNo}
                  </td>
                  {/* <td
                    style={{ borderBottom: "1px solid black", height: "29px" }}
                  >
                    {r.date}
                  </td> */}
                  <td>
                    {r.discount?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r.commission}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head">
        <h5>Staff Expense</h5>
        <h5>
        {(ShiftBillTypeSummary?.staffExpense?.total||0)?.toFixed(decimalPosition) }
        </h5>
      </div>
      {!showSubHeaders && paymentTypeSplit && staffExpBreakdown.length > 0 && (
        <table>
          <tbody>
            {staffExpBreakdown.map((item, i) => (
              <tr key={i}>
                <td style={{ paddingLeft: "10px", fontSize: "11px" }}>{item.type}</td>
                <td style={{ textAlign: "right", fontSize: "11px" }}>{item.amount?.toFixed(decimalPosition)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Expense</th>
              <th>Emp</th>
              <th>Date</th>
              <th>Paid By</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.staffExpense?.list !== undefined ? (
              ShiftBillTypeSummary?.staffExpense?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.expense}
                  </td>
                  <td>
                    {r.employee}
                  </td>
                  <td>
                    {r.date}
                  </td>
                  <td>
                    {r.paymentType}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head"
      >
        <h5>Outlet Expense</h5>
        <h5>
        {(ShiftBillTypeSummary?.outletExpense?.total || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {!showSubHeaders && paymentTypeSplit && outletExpBreakdown.length > 0 && (
        <table>
          <tbody>
            {outletExpBreakdown.map((item, i) => (
              <tr key={i}>
                <td style={{ paddingLeft: "10px", fontSize: "11px" }}>{item.type}</td>
                <td style={{ textAlign: "right", fontSize: "11px" }}>{item.amount?.toFixed(decimalPosition)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Shift ID</th>
              <th>Doc No</th>
              <th>Expense</th>
              <th>Date</th>
              <th>Paid By</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.outletExpense?.list !== undefined ? (
              ShiftBillTypeSummary?.outletExpense?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.shift}
                  </td>
                  <td>
                    {r.docNo}
                  </td>
                  <td>
                    {r.expense}
                  </td>
                  <td>
                    {r.date}
                  </td>
                  <td>
                    {r.paymentType}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head">
        <h5>Refund</h5>
        <h5>
        {(ShiftBillTypeSummary?.refund?.total || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>O/ID</th>
              <th>Product</th>
              <th>Type</th>
              {/* <th>Date</th> */}
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.refund?.list !== undefined ? (
              ShiftBillTypeSummary?.refund?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.billNo}
                  </td>
                  <td className='product-column'>
                    <div>
                      {r.product}
                    </div>
                  </td>
                  <td>
                    {r.type}
                  </td>
                  {/* <td>
                    {r.date}
                  </td> */}
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head">
        <h5>Cash & Card</h5>
        <h5>
        {(ShiftBillTypeSummary?.cashAndCard?.total ||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {!showSubHeaders && cashCardSplit && cashCardGroups?.length > 0 && (
        <table>
          <tbody>
            {cashCardGroups.map((group, gi) => (
              <React.Fragment key={gi}>
                <tr>
                  <td style={{ paddingLeft: "10px", fontSize: "11px", fontWeight: "bold", textTransform: "capitalize" }}>{group.type}</td>
                  <td style={{ textAlign: "right", fontSize: "11px", fontWeight: "bold" }}>{group.total?.toFixed(decimalPosition)}</td>
                </tr>
                {group.items.map((r, i) => (
                  (r?.cardName || r?.journalName) && (
                    <tr key={`${gi}-${i}`}>
                      <td style={{ paddingLeft: "20px", fontSize: "10px" }}>{[r?.cardName, r?.journalName].filter(Boolean).join(" - ")}</td>
                      <td style={{ textAlign: "right", fontSize: "10px" }}>{r?.amount?.toFixed(decimalPosition)}</td>
                    </tr>
                  )
                ))}
              </React.Fragment>
            ))}
            {cashCardFilterActive && (
              <tr>
                <td style={{ paddingLeft: "10px", fontSize: "11px", fontWeight: "bold" }}>Selected Total</td>
                <td style={{ textAlign: "right", fontSize: "11px", fontWeight: "bold" }}>{filteredCashCardTotal?.toFixed(decimalPosition)}</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Pay Method</th>
              <th>Amount</th>
              <th>Comm.</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.cashAndCard?.list !== undefined ? (
              ShiftBillTypeSummary?.cashAndCard?.list?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r.type}
                  </td>
                  <td>
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r.commission?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r.balance?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {ShiftBillTypeSummary?.cashAfterExpenses?.show && (
        <div className="bill-sub-head">
          <h5>Cash After Expenses</h5>
          <h5>
            {(ShiftBillTypeSummary?.cashAfterExpenses?.total || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
      )}
      {afterExpensesRows.length > 0 && afterExpensesRows.map((row, i) => (
        <div key={i} className="bill-sub-head">
          <h5 style={{ fontSize: "11px" }}>{row.type}</h5>
          <h5 style={{ fontSize: "11px" }}>{row.amount?.toFixed(decimalPosition)}</h5>
        </div>
      ))}
      {ShiftBillTypeSummary?.pettyCashInfo?.show && (
        <div className="bill-sub-head">
          <h5>Petty Cash</h5>
          <h5>
            {(ShiftBillTypeSummary?.pettyCashInfo?.remaining || 0)?.toFixed(decimalPosition)}
          </h5>
        </div>
      )}
      {showSubHeaders && ShiftBillTypeSummary?.pettyCashInfo?.show && (
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Balance</td>
              <td>{(ShiftBillTypeSummary?.pettyCashInfo?.balance || 0)?.toFixed(decimalPosition)}</td>
            </tr>
            <tr>
              <td>Spent</td>
              <td>{(ShiftBillTypeSummary?.pettyCashInfo?.spent || 0)?.toFixed(decimalPosition)}</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>Remaining</td>
              <td style={{ fontWeight: "bold" }}>{(ShiftBillTypeSummary?.pettyCashInfo?.remaining || 0)?.toFixed(decimalPosition)}</td>
            </tr>
          </tbody>
        </table>
      )}
        <div
        className="bill-sub-head"
      
      >
        <h5>Delivery Charge</h5>
        <h5>
          {(ShiftBillTypeSummary?.deliveryCharge?.total ||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead >
            <tr>
              <th>Bill No</th>
              <th>Amount</th>
            
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.deliveryCharge?.list !== undefined ? (
              ShiftBillTypeSummary?.deliveryCharge?.list?.map((r, i) => (
                <tr key={i}>
                  <td
                    style={{ borderBottom: "1px solid black", height: "29px" }}
                  >
                    {r.billNo}
                  </td>
                  <td
                    style={{ borderBottom: "1px solid black", height: "29px" }}
                  >
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div
        className="bill-sub-head"
       
      >
        <h5>Packing Charge</h5>
        <h5>
          {(ShiftBillTypeSummary?.packagingCharge?.total ||0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Amount</th>
             
            </tr>
          </thead>
          <tbody>
            {ShiftBillTypeSummary?.packagingCharge?.list !== undefined ? (
              ShiftBillTypeSummary?.packagingCharge?.list?.map((r, i) => (
                <tr key={i}>
                  <td
                    style={{ borderBottom: "1px solid black", height: "29px" }}
                  >
                    {r.billNo}
                  </td>
                  <td
                    style={{ borderBottom: "1px solid black", height: "29px" }}
                  >
                    {r.amount?.toFixed(decimalPosition)}
                  </td>
                 
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default BillTypeSummaryPrint